/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import _ from 'lodash';
import { AlertData, AlertRequest } from 'models/viewModels';
import { RSocketChannelBaseService } from './RSocketChannelBaseService';

export class AlertDataService extends RSocketChannelBaseService<AlertRequest, AlertData, AlertData> {
  private currentFilter: AlertRequest | undefined = undefined;

  // This method is called in RSocketBaseService to set the initial request
  protected async getStreamRequest() {
    return this.currentFilter;
  }

  // Backfill is handled by the alertStreamManagement
  // the onDataCallback doesn't use the localCache either so we don't need to preemptively set localCache to the backfill
  protected getStreamHistoryRequest(): Promise<AlertData | undefined> {
    return Promise.resolve(undefined);
  }

  // When the channel receives data, it is sent to the listeners (AKA the first function in the addListener)
  protected onDataCallback = (response: AlertData) => {
    this.listeners.forEach((listener) => listener(response));
  };

  // This is used to see what the channel is currently using as a filter
  public isStreamActiveByFilter(filter: AlertRequest) {
    return _.isEqual(this.currentFilter, filter);
  }

  public getCurrentFilter() {
    return this.currentFilter;
  }

  public setCurrentFilter(filter: AlertRequest) {
    this.currentFilter = filter;
  }

  // This sends a new request to the channel with the requested filter
  public updateRequest(filter: AlertRequest) {
    this.setCurrentFilter(filter);
    this.updateStreamRequest(filter);
  }
}
